import { getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import { grey300 } from 'ext-ui/style/colors'
import { transition_slow } from 'ext-ui/style/transitionSpeeds'
import variables from 'src/style/variables.json'
import { css } from 'styled-components'

export default css`
  &.UtilityToolbarDropdown {
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: flex-end;

    & .handleContainer {
      display: inline-block;
      position: relative;
    }

    & .button {
      &:hover:not(.selected) {
        background-color: ${grey300};
      }

      &.selected {
        background-color: ${styleConstants.colors.blue_opacity};
        border: 1px solid ${themeConstants.colors.cta};
      }
    }

    & .image {
      max-width: ${variables.units['base-unit-5']}px;
      max-height: ${variables.units['base-unit-5']}px;
      margin-right: ${variables.units['base-unit-1']}px;
    }

    & .label {
      ${getFontCss(
        14,
        themeConstants.colors.cta,
        styleConstants.fontFamilies.medium,
      )};
    }

    & .icon {
      margin-left: 4px;
      transition: transform ${transition_slow};
      transform: rotate(180deg);
      &.open {
        transform: rotate(0deg);
      }
    }

    & .dropdownContainer {
      position: absolute;
      top: 100%;
      right: ${variables.units[
        'base-unit-0'
      ]}px;
      padding: ${variables.units['base-unit-5']}
        ${variables.units['base-unit-0']}px;
      z-index: 4;
      width: 347px;
      display: flex;
      flex-direction: column;
      margin-top: ${variables.units['base-unit-1']}px;
    }
  }
`
